import { Button, Checkbox, DataHeader, DataSource, Label, Layout, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutReportSchedule extends Layout {
    buttonHistory: Button;
    checkboxCreateEmptyRpt: Checkbox;
    checkboxIndivUserReport: Checkbox;
    checkboxNotifyByRapAlrt: Checkbox;
    checkboxRunFriday: Checkbox;
    checkboxRunMonday: Checkbox;
    checkboxRunSaturday: Checkbox;
    checkboxRunSunday: Checkbox;
    checkboxRunThursday: Checkbox;
    checkboxRunTuesday: Checkbox;
    checkboxRunWednesday: Checkbox;
    dataheaderTitle: DataHeader;
    labelDayMonthPrefix: Label;
    labelDayMonthSuffix: Label;
    labelGeneral: Label;
    labelMonthFrequencyPrefix: Label;
    labelMonthFrequencySuffix: Label;
    labelNotification: Label;
    labelSchedule: Label;
    panelDailyOptions: Panel;
    panelDayMonthOptions: Panel;
    panelGeneral: Panel;
    panelLeft: Panel;
    panelNotification: Panel;
    panelRight: Panel;
    panelSchedule: Panel;
    panelWeekdayMonthOptions: Panel;
    sourceReportSchedule: DataSource;
    switchIsActive: Switch;
    textboxBeginningTime: Textbox;
    textboxDescr: Textbox;
    textboxEffectiveFrom: Textbox;
    textboxEffectiveTo: Textbox;
    textboxEmailProfileId: Textbox;
    textboxEndingTime: Textbox;
    textboxId: Textbox;
    textboxMonthDay: Textbox;
    textboxMonthFrequency: Textbox;
    textboxMonthlyDate: Textbox;
    textboxNextGenerateDate: Textbox;
    textboxNotifyByEmail: Textbox;
    textboxNotifyEmailAddrs: Textbox;
    textboxNotifyEmailSubject: Textbox;
    textboxNotifyGroups: Textbox;
    textboxNotifyUsers: Textbox;
    textboxRecurringDate: Textbox;
    textboxRecurringTime: Textbox;
    textboxReportClass: Textbox;
}
